import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserInfo } from 'Store/Auth/Auth.selector';
import { AiIcon } from '../../components/AiIcon';
import { AiIconName } from '../../Utils/icons';
import { aiChatImages } from '../../Utils/images';
import {
  Badge,
  Description,
  EmptyStateContainer,
  PromptCard,
  PromptDetails,
  PromptIcon,
  Prompts,
  Title,
  Welcome
} from './styles';

const PROMPTS: { key: string; icon: AiIconName }[] = [
  { key: 'promptWeekly', icon: 'promptCalendar' },
  { key: 'promptHighPriority', icon: 'promptAlertTriangle' },
  { key: 'promptDiscipline', icon: 'promptDiscipline' },
  { key: 'promptOverdue', icon: 'promptClock' }
];

const getFirstName = (name?: string) => name?.trim().split(' ')[0] ?? '';

export const EmptyState: FC<{ onSelectPrompt: (prompt: string) => void }> = ({
  onSelectPrompt
}) => {
  const { t } = useTranslation('activities');
  const userInfo = useSelector(getUserInfo);
  const firstName = getFirstName(userInfo?.Nome);

  return (
    <EmptyStateContainer>
      <Welcome>
        <Badge>
          <img src={aiChatImages.sparkles} alt="" />
          <span>{t('aiChat.assistantLabel')}</span>
        </Badge>
        <Title>
          {firstName ? (
            <>
              {t('aiChat.greeting')} <span className="name">{firstName}</span>!
            </>
          ) : (
            t('aiChat.greetingNoName')
          )}
          <span className="subtitle">{t('aiChat.subtitleAsk')}</span>
        </Title>
        <Description>{t('aiChat.selectPrompt')}</Description>
      </Welcome>

      <Prompts>
        {PROMPTS.map(({ key, icon }) => (
          <PromptCard
            key={key}
            type="button"
            onClick={() => onSelectPrompt(t(`aiChat.${key}Value`))}
          >
            <PromptIcon>
              <AiIcon name={icon} />
            </PromptIcon>
            <PromptDetails>
              <strong>{t(`aiChat.${key}Title`)}</strong>
              <span>{t(`aiChat.${key}Desc`)}</span>
            </PromptDetails>
          </PromptCard>
        ))}
      </Prompts>
    </EmptyStateContainer>
  );
};
